var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Language-2",
    "data-name": "Language",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Language",
    width: 24,
    height: 24,
    fill: "#070707"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_30",
    "data-name": "Mask Group 30",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "language-3",
    "data-name": "language",
    transform: "translate(-0.706 -0.706)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M17.213,12.706C17.213,18.944,12.7,24,12.7,24S8.2,18.944,8.2,12.706,12.7,1.412,12.7,1.412,17.213,6.467,17.213,12.706Z",
    fill: "none",
    stroke: "#070707",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    strokeWidth: 1.412
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M3.989,5.523A17.355,17.355,0,0,0,12.705,8.2a17.355,17.355,0,0,0,8.716-2.674",
    fill: "none",
    stroke: "#070707",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    strokeWidth: 1.412
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M1.412,12.706H24",
    fill: "none",
    stroke: "#070707",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    strokeWidth: 1.412
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M21.427,19.888a17.356,17.356,0,0,0-8.716-2.674,17.356,17.356,0,0,0-8.716,2.674",
    fill: "none",
    stroke: "#070707",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    strokeWidth: 1.412
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M12.706,24A11.294,11.294,0,1,0,1.412,12.706,11.294,11.294,0,0,0,12.706,24Z",
    fill: "none",
    stroke: "#070707",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    strokeWidth: 1.412
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageIcon);
export default __webpack_public_path__ + "static/media/language-icon.4fa47b61d1f446176414081a7d067a31.svg";
export { ForwardRef as ReactComponent };